var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M7 15L12 10 17 15z",
      "transform": "matrix(1 0 0 -1 0 24)"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }